var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"placeholder":_vm.$t('common.selects.standard'),"track-by":"standard","label":"standard","id":"standard_id","options":_vm.options},model:{value:(_vm.internalState),callback:function ($$v) {_vm.internalState=$$v},expression:"internalState"}})
}
var staticRenderFns = []

export { render, staticRenderFns }